module.exports = __webpack_public_path__ + "static/img/5.ae9f1d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/5.png
// module id = NLXP
// module chunks = 2